module.exports = __webpack_public_path__ + "img/cnd_Team.02d27c2b.svg";